import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  notifications: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedNotification:null
};

/* ================== THUNKS ================== */

export const fetchPushNotifications = createAsyncThunk(
  'push-notifications/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/api/admin/push-notifications', {
          params: { fetchType, page, limit, search }
        });
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createPushNotification = createAsyncThunk(
  'push-notifications/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/push-notifications', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const fetchPushNotificationById = createAsyncThunk(
  'push-notifications/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/push-notifications/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updatePushNotification = createAsyncThunk(
  'push-notifications/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/push-notifications/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const deletePushNotification = createAsyncThunk(
  'push-notifications/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/push-notifications/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const sendPushNotification = createAsyncThunk(
  'push-notifications/send',
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/api/admin/push-notifications/send/${id}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);




/* ================== SLICE ================== */

const PushNotificationSlice = createSlice({
  name: 'push-notifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        /* FETCH */
        .addCase(fetchPushNotifications.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchPushNotifications.fulfilled, (state, action) => {
            const { data, pagination } = action.payload;
            state.loading = false;
            state.pagination = pagination;
            state.notifications = data;
        })
        .addCase(fetchPushNotifications.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(fetchPushNotificationById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedNotification = action.payload;
        })
        .addCase(fetchPushNotificationById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        /* UPDATE */
        .addCase(updatePushNotification.fulfilled, (state, action) => {        
            console.log(state,'state');
        })
        .addCase(updatePushNotification.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(sendPushNotification.fulfilled, (state, action) => {
            state.loading = false;
            
        })       
        /* DELETE */
        .addCase(deletePushNotification.fulfilled, (state, action) => {
          state.notifications = state.notifications.filter((p) => p._id !== action.payload);
        });
  }
});

export default PushNotificationSlice.reducer;